import { createContext, useContext, useEffect, useCallback, useMemo } from 'react';
import { useDispatch } from "react-redux";
import { drawerAction, setCartStatus, setDrawerContent, setDrawerTitle, setMembershipStatus, setPackageStatus } from "../../store/features/deviceSlice";
import { setToken } from "../../store/features/tokenSlice";
import getOrigins from '../../utils/getOrigins';
import AppConstants from '../../constants/AppConstants';
import cookieService from '../../services/cookieService';

const DrawerContext = createContext();
export const useDrawer = () => useContext(DrawerContext);

export function DrawerProvider({ children }) {
  const dispatch = useDispatch();

  const openDrawer = useCallback(async (content, title = '') => {
    dispatch(setDrawerContent(content));
    dispatch(setDrawerTitle(title));
    dispatch(drawerAction(true));
  }, [dispatch]);

  const closeDrawer = useCallback(() => {
    dispatch(drawerAction(false));
  }, [dispatch]);

  useEffect(() => {
    const handleMessage = async (event) => {
      const { type, payload } = event.data;
      if (type === "MY_IFRAME_EVENT") {
        if (payload?.isAuthenticated) {
          const getToken = cookieService.get(AppConstants.CS_KEY.ACCESS_TOKEN);
          dispatch(setToken(getToken));
          if (localStorage.getItem('ticketType') === 'tickets') {
            dispatch(setCartStatus(true));
          } else if (localStorage.getItem('ticketType')  === 'membership') {
            dispatch(setMembershipStatus(true))
          } else if (localStorage.getItem('ticketType') === 'packages') {
            dispatch(setPackageStatus(true));
          }
        } else if (payload?.path) {
          window.location.replace(`${getOrigins(window)}/${payload?.path}`);
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [dispatch, openDrawer]);

  const drawerContextValue = useMemo(() => ({
    openDrawer,
    closeDrawer,
  }), [openDrawer, closeDrawer]);

  return (
    <DrawerContext.Provider value={drawerContextValue}>
      {children}
    </DrawerContext.Provider>
  );
}
